import React, { FC } from "react";
import {
  FlexContainer,
  CustomLabel,
  Input,
  TableContainer,
  TableRow,
  TableData,
  THead,
  TableHead,
  TBody,
  StatusCircle,
  UtilityMethods,
} from "@mindmemobile/mm-shared-global";
import { Table } from "react-bootstrap";
import {
  PricingPageInputModel,
  ProductAttributeMappingsInput,
} from "../../../shared/models";
import { VariantWrapper } from "../../../shared/styles";
import { AuthService } from "../../../shared/services";
import { AccountSettingsStore } from "../../../shared/store";

type VariantsTableProps = {
  variants: ProductAttributeMappingsInput[];
  showOnHand: boolean;
  selectedVariantIds: string[];
  handleCheckboxChange: (variantId: string, isChecked: boolean) => void;
  showPriceByVariant: boolean;
  priceDetails?: PricingPageInputModel | null;
};

const PurchaseLinkVariantTable: FC<VariantsTableProps> = ({
  variants,
  showOnHand,
  selectedVariantIds,
  handleCheckboxChange,
  showPriceByVariant,
  priceDetails,
}) => {
  const getPrice = () => {
    if (priceDetails) {
      switch (priceDetails.billingType) {
        case "Term":
          switch (priceDetails.termSettings?.pricingModel) {
            case "Standard":
              return priceDetails.termSettings?.standardPricing?.price;
            case "Volume":
              return priceDetails.termSettings?.volumePricing?.price;
            case "Tiered":
              return priceDetails.termSettings?.tieredPricing?.price;
            case "Package":
              return priceDetails.termSettings?.packagePricing?.options[0]
                .price;
            case "Custom":
              return priceDetails.termSettings?.customPricing?.suggestion;
          }
          break;
      }
    }
    return "0";
  };

  const renderVariantRow = (option: ProductAttributeMappingsInput) => {
    const isOutOfStock = option.onHand === "0" && showOnHand;
    const isChecked = selectedVariantIds.includes(option.id);
    return (
      <TableRow key={option.id}>
        <TableData>
          <FlexContainer alignItems="center" spacing={10}>
            <Input
              value={isChecked}
              id={`chk${option.id}`}
              type="checkbox"
              label=""
              onChange={(e) =>
                handleCheckboxChange(option.id, e.target.checked)
              }
              disabled={isOutOfStock}
            />
            <StatusCircle heightWidth="14px" inActive={isOutOfStock} />
            <CustomLabel>{option.name}</CustomLabel>
          </FlexContainer>
        </TableData>
        <TableData className="variant-price-col">
          <CustomLabel>
            $
            {AccountSettingsStore.formatAmount(
              parseFloat(
                showPriceByVariant
                  ? option.price === ""
                    ? "0"
                    : option.price
                  : getPrice() || "0"
              )
            )}{" "}
            USD
          </CustomLabel>
        </TableData>
        {showOnHand && (
          <TableData className="on-hand-col">
            <CustomLabel>{option.onHand}</CustomLabel>
          </TableData>
        )}
      </TableRow>
    );
  };

  return (
    <VariantWrapper>
      <TableContainer>
        <Table
          cellSpacing="20"
          className="table item-variant-table variant-table-chckbx"
        >
          <THead>
            <TableHead className="variant-header">VARIANT</TableHead>
            <TableHead className="variant-price-col">PRICE</TableHead>
            {showOnHand && (
              <TableHead className="on-hand-col">ON HAND</TableHead>
            )}
          </THead>
          <TBody fromPaymentSystem={AuthService.fromPaymentSystem}>
            {variants.map((option) => renderVariantRow(option))}{" "}
          </TBody>
        </Table>
      </TableContainer>
    </VariantWrapper>
  );
};

export default PurchaseLinkVariantTable;
